import {connect} from "react-redux";
import {
  getDashboardCounts,
} from '../actions/actions-reports-global';
import DashboardCounts from '../views/DashboardCounts/DashboardCounts';
const mapStateToProps = (state, ownProps) => {
  return {
    reportStats: state.globalR,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getDashboardCounts: (loginID) => {
      dispatch(getDashboardCounts(loginID) );},
  };
};
const DashboardCountsContainer = connect(mapStateToProps, mapDispatchToProps)(DashboardCounts);
export default DashboardCountsContainer;




                      // console.log ( '4444-4451  - DashboardCounts - state = ', state);
                      // console.log ( '4444-4452  - DashboardCounts - state.globalR = ', state.globalR);
                      // console.log ( '4444-4453  - DashboardCounts - ownProps = ', ownProps);
